"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    row: 'c-LocationFieldInput',
    label: 'c-LocationFieldInput__label',
    inputs: 'c-LocationFieldInput__input',
    error: 'c-LocationFieldInput__error',
    MDL: {
        error: 'mdl-textfield__error'
    }
};
exports.Style = (_a = {},
    _a[exports.CSS.row] = {
        display: 'block',
        'align-items': 'center'
    },
    _a[exports.CSS.label] = {
        display: 'inline-block',
        width: '25%'
    },
    _a[exports.CSS.inputs] = {
        display: 'inline-block',
        width: '75%'
    },
    _a[exports.CSS.error] = {
        visibility: 'visible',
        position: 'relative'
    },
    _a);
//# sourceMappingURL=LocationField.input.style.js.map